import styled from 'styled-components';
import { theme } from '../../../../theme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
`;

export const Modal = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 768px;
  width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;

  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

export const ModalContent = styled.div`
  padding: 24px 40px 40px;
  text-align: center;

  h2 {
    color: #0f172a;
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  p {
    color: #475569;
    font-size: 24px;
    line-height: 1.5;
    margin-bottom: 12px;
  }

  .button-container {
    display: flex;
    gap: 12px;
    margin-top: 40px;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 480px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  .btn {
    appearance: none;
    background: none;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    display: block;
    padding: 16px 40px;
    border-radius: 8px;
    font-size: 24px;
    font-weight: 600;
    transition: all 0.2s ease;
    min-width: 180px;
    height: 72px;

    &.primary {
      background: ${theme.bootsBlue};
      color: white;

      &:hover {
        opacity: 0.9;
      }
    }

    &.secondary {
      border: 2px ${theme.error} solid;
      color: ${theme.error};
      background: white;

      &:hover {
        background: rgba(0, 102, 204, 0.05);
      }
    }
  }
`;